<template>
    <div class="flex flex-col space-y-px">
        <slot></slot>
    </div>
</template>
